import { config } from '@/config';

/**
 * Triggers a password reset email for the given address.
 *
 * The backend generates the Firebase reset link and sends a branded email via
 * our own transport (Postmark) — we intentionally do NOT call Firebase's
 * sendPasswordResetEmail from the client, which would deliver a second,
 * unbranded email. The reset link works for both email/password users and
 * Google OAuth users: it lets the recipient set (or reset) a password,
 * enabling email/password sign-in alongside any existing providers.
 *
 * All errors are swallowed — callers always show the same confirmation UI
 * to prevent user enumeration.
 */
export async function requestPasswordReset(email: string): Promise<void> {
  await fetch(`${config.authUrl}/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email }),
  }).catch(() => {
    // Swallow network errors — confirmation UI is identical regardless.
  });
}
